export var componentsLocales = {
  selectMonthAriaLabel: 'month',
  selectYearAriaLabel: 'year',
  selectChosenAriaLabel: 'Chosen',
  selectChooseAriaLabel: 'Choose'
};